import { Link, useParams, Navigate } from "react-router-dom";
import { motion } from "framer-motion";
import { SEO } from "../components/SEO";
import { ArticleRenderer } from "../components/ArticleRenderer";
import { EmailOptInForm } from "../components/EmailOptInForm";
import { getGuideBySlug, GUIDES } from "../data/guides";

export default function GuidePage() {
  const { slug } = useParams();
  const guide = getGuideBySlug(slug);
  if (!guide) return <Navigate to="/guides" replace />;
  const related = GUIDES.filter((g) => g.slug !== slug).slice(0, 3);

  return (
    <>
      <SEO title={guide.title} description={guide.metaDescription} image={guide.heroImage} />

      <section className="relative pt-36 pb-16 px-6 lg:px-10 spotlight">
        <div className="max-w-4xl mx-auto">
          <motion.p initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="font-mono-tag text-xs uppercase tracking-[0.2em] text-gold mb-4">Guide</motion.p>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="font-display font-black text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-tight">
            {guide.title}
          </motion.h1>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35, duration: 0.6 }} className="mt-8 rounded-sm overflow-hidden border border-white/10 aspect-[16/7]">
            <img src={guide.heroImage} alt={guide.title} className="w-full h-full object-cover" />
          </motion.div>
        </div>
      </section>

      <section className="px-6 lg:px-10 pb-16">
        <div className="max-w-4xl mx-auto">
          <ArticleRenderer blocks={guide.blocks} />
        </div>
      </section>

      <section className="px-6 lg:px-10 pb-16">
        <div className="max-w-4xl mx-auto border border-white/10 rounded-sm p-8 spotlight">
          <h3 className="font-display font-bold text-xl text-white mb-2">Want the templates behind this guide?</h3>
          <p className="text-zinc-400 text-sm mb-5">Get our free 20+ prompt library covering every use case on this site.</p>
          <EmailOptInForm source={`guide_${slug}`} />
        </div>
      </section>

      <section className="px-6 lg:px-10 pb-24 border-t border-white/10 pt-16">
        <div className="max-w-4xl mx-auto">
          <p className="font-mono-tag text-xs uppercase tracking-[0.2em] text-gold mb-6">More Guides</p>
          <div className="grid sm:grid-cols-3 gap-6">
            {related.map((g) => (
              <Link key={g.slug} to={`/guides/${g.slug}`} className="group border border-white/10 rounded-sm overflow-hidden hover:border-primary/50 transition-colors">
                <img src={g.heroImage} alt={g.title} className="w-full h-28 object-cover grayscale group-hover:grayscale-0 transition-all duration-500" />
                <div className="p-4"><p className="text-white text-sm font-medium leading-snug line-clamp-2">{g.title}</p></div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
